/**
 * Rotas do domínio ControleAcesso — R5 (rota é a fronteira física da
 * migração). Movido de `src/router/rotas/ControleAcesso.ts` na T85; os
 * componentes agora resolvem por caminho relativo, dentro do próprio
 * domínio, em vez de `@/views/...`.
 *
 * Dois hubs consomem os dois arrays daqui — `rotaPerfil` por
 * `router/rotas/Geral.ts` (espalha `/usuarios/:user?` no `LayoutGeral`) e
 * `rotaAdicionarUsuarioObra` por `router/rotas/Obra.ts` (espalha
 * `usuarios/adicionar` dentro de `/:obra/`, `LayoutObra`) — os dois pelo
 * BARREL (`@/views/ControleAcesso`), não pelo caminho interno.
 *
 * `router/rotas/Fabricacao.ts` é um TERCEIRO consumidor, e não usa nenhum
 * dos dois arrays: ele declara a PRÓPRIA rota (path e nome diferentes,
 * `/fabricacao/:obra/usuarios/adicionar`), reusando só o COMPONENTE
 * `ControleAcessoAdicionarUsuario` pelo barrel — por isso ele também
 * precisa constar em `.hubs-dominio.json`.
 */
export const rotaPerfil = [
  {
    path: "/usuarios/:user?",
    name: "Perfil",
    component: () => import("./ControleAcessoPerfil.vue"),
    meta: {
      title: "Perfil",
      subject: ["PERFIL"],
      icon: "mdi-account",
      showMenu: true,
    },
  },
];

export const rotaAdicionarUsuarioObra = [
  {
    path: "usuarios/adicionar",
    // Nome próprio: "Adicionar Usuários" é o da rota de Fabricação, e o vue-router
    // remove a rota anterior de mesmo nome — esta nunca resolvia (ROT-01).
    name: "Adicionar Usuários da Obra",
    component: () => import("./ControleAcessoAdicionarUsuario.vue"),
    meta: {
      breadcrumb: "Adicionar Usuários",
      obraObrigatoria: true,
      title: "Adicionar Usuários",
      icon: "mdi-text-box-multiple-outline",
      subject: ["Usuario"],
      showMenu: true,
    },
  },
];

/**
 * Telas de governança de acesso (T109, GOV-03, `docs/TELAS-CONTROLE-ACESSO.md`
 * §2) — `meta.subject`/`meta.action` seguem exatamente a tabela do doc:
 * leitura para a lista, `editar` para criar/editar. O sujeito `"Permissao"`
 * é o mesmo que `ControleAcesso.vue` já usa via `podeNoModulo` — nenhum
 * sujeito novo entra no catálogo.
 */
export const rotasGrupos = [
  {
    path: "/controle-acesso/grupos",
    name: "Grupos de Acesso",
    component: () => import("./ListaGrupos.vue"),
    meta: {
      breadcrumb: "Grupos de Acesso",
      title: "Grupos de Acesso",
      icon: "mdi-account-group",
      subject: ["Permissao"],
      action: ["read"],
      showMenu: true,
    },
  },
];

/**
 * Telas 2 e 4 (T110, GOV-04, doc §2) — editor de grupo, novo e existente. O
 * bloqueio (tela 4) não é rota própria: é estado de `EditorGrupo.vue` quando
 * o grupo carregado tem papel fora do escopo do admin.
 */
export const rotasEditorGrupo = [
  {
    path: "/controle-acesso/grupos/novo",
    name: "Novo Grupo de Acesso",
    component: () => import("./EditorGrupo.vue"),
    meta: {
      breadcrumb: "Grupos de Acesso|Novo",
      title: "Novo grupo",
      icon: "mdi-account-group",
      subject: ["Permissao"],
      action: ["editar"],
      showMenu: false,
    },
  },
  {
    path: "/controle-acesso/grupos/:nome/editar",
    name: "Editar Grupo de Acesso",
    component: () => import("./EditorGrupo.vue"),
    meta: {
      breadcrumb: "Grupos de Acesso|Editar",
      title: "Editar grupo",
      icon: "mdi-account-group",
      subject: ["Permissao"],
      action: ["editar"],
      showMenu: false,
    },
  },
];

/** Tela 3 (T111, GOV-05, doc §2). */
export const rotaAtribuirAcesso = [
  {
    path: "/controle-acesso/atribuir",
    name: "Atribuir Acesso",
    component: () => import("./AtribuirAcesso.vue"),
    meta: {
      breadcrumb: "Atribuir Acesso",
      title: "Atribuir acesso",
      icon: "mdi-account-plus",
      subject: ["Permissao"],
      action: ["editar"],
      showMenu: true,
    },
  },
];
